/**
 * Civil Nexus - Storage Quota & Eviction Shield
 * تضمین ماندگاری داده در برابر سیاست‌های Eviction مرورگر
 */

export const storageQuota = {
  // درخواست ماندگاری پایدار (Persistent Storage)
  requestPersistence: async () => {
    if (navigator.storage && navigator.storage.persist) {
      const isPersisted = await navigator.storage.persist();
      console.log(`[Storage] Persistent storage granted: ${isPersisted}`);
      return isPersisted;
    }
    return false;
  },

  // محاسبه دقیق حجم مصرفی و فضای آزاد
  getEstimate: async () => {
    if (navigator.storage && navigator.storage.estimate) {
      const estimate = await navigator.storage.estimate();
      const usedMB = Math.round((estimate.usage || 0) / (1024 * 1024));
      const quotaMB = Math.round((estimate.quota || 0) / (1024 * 1024));
      const percent = quotaMB > 0 ? Math.round((usedMB / quotaMB) * 100) : 0;
      return { usedMB, quotaMB, percent };
    }
    return { usedMB: 0, quotaMB: 0, percent: 0 };
  }
};
